/** 页面路径，也写进 metadata.page，按入口拆使用量靠它 */
export const AI_MUSIC_PAGE_PATH = "/ai-music-generator";

/** 和后端 music-generator/lib/config.ts 对齐 */
export const MUSIC_GENERATION_COST = 12;
export const MUSIC_VISUALIZER_COST = 2;
export const MUSIC_LIMITS = {
	prompt: 500,
	style: 1000,
	lyrics: 5000,
	title: 80,
	lyricsPrompt: 200,
} as const;

/** 页面上不出现 Suno 字样，版本只叫 Standard / Creative */
export const MUSIC_MODEL_OPTIONS = [
	{ id: "V6", labelKey: "standard" },
	{ id: "V6_WILD", labelKey: "creative" },
] as const;
export type MusicModelId = (typeof MUSIC_MODEL_OPTIONS)[number]["id"];
export const MODEL_LABEL_KEYS = Object.fromEntries(
	MUSIC_MODEL_OPTIONS.map((option) => [option.id, option.labelKey]),
) as Record<MusicModelId, (typeof MUSIC_MODEL_OPTIONS)[number]["labelKey"]>;

/** 秒 → m:ss */
export function formatDuration(seconds?: number) {
	if (!seconds) {
		return "";
	}
	const total = Math.round(seconds);
	return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

/**
 * 风格标签：点一下追加进 Styles。选项照 SuperMaker 的表精简，每组 8–12 个；
 * 是直接拼进 prompt 的英文风格词，不做翻译。
 */
export const STYLE_TAG_GROUPS = [
	{
		key: "genre",
		tags: [
			"pop",
			"rock",
			"hip hop",
			"r&b",
			"edm",
			"country",
			"jazz",
			"lo-fi",
			"k-pop",
			"folk",
			"metal",
			"classical",
		],
	},
	{
		key: "mood",
		tags: [
			"happy",
			"sad",
			"romantic",
			"chill",
			"energetic",
			"dreamy",
			"dark",
			"epic",
			"nostalgic",
			"uplifting",
		],
	},
	{
		key: "voice",
		tags: [
			"female vocal",
			"male vocal",
			"duet",
			"choir",
			"soft vocal",
			"powerful vocal",
			"rap",
			"whisper",
		],
	},
	{
		key: "tempo",
		tags: [
			"slow",
			"mid-tempo",
			"upbeat",
			"fast",
			"70 bpm",
			"90 bpm",
			"120 bpm",
			"140 bpm",
		],
	},
] as const;

/** 每 3 秒查一次状态；Suno 出 2 首实测 20–70 秒 */
export const MUSIC_POLL_INTERVAL_MS = 3000;

export const MUSIC_HISTORY_PAGE_SIZE = 10;
